import {
	hasSpaceWithProjectName,
	getBlankSpaceBlueprintId,
	spaceNameToSpaceKey,
	generateSpaceKey,
	createSpace,
} from './utils.tsx';

export const createSpaceForProjectName = async (projectName: string) => {
	if (!projectName) return;

	const key = await hasSpaceWithProjectName(projectName);

	if (key) {
		return { key, spaceCreated: false };
	}

	const spaceKey = spaceNameToSpaceKey(projectName);

	if (!spaceKey) {
		return;
	}

	const [blankSpaceBlueprintId, generatedSpaceKey] = await Promise.all([
		getBlankSpaceBlueprintId(),
		generateSpaceKey(spaceKey),
	]);

	if (!generatedSpaceKey || !blankSpaceBlueprintId) {
		return;
	}

	const data = await createSpace({
		spaceName: projectName,
		spaceKey: generatedSpaceKey,
		spaceBlueprintId: blankSpaceBlueprintId,
	});

	const updatedData = {
		...data,
		spaceCreated: true,
	};

	return updatedData;
};
